import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {AnalysisMainViewItem, AnalysisMainViewItemType} from 'analysis-tool/ui/main-view/MainViewTypes';
import isExperimentOptimizationEnabled from 'machine-learning/isExperimentOptimizationEnabled';
import configureAndApplyStaticTemplate from 'pipelines/static-templates/configureAndApplyStaticTemplate';
import {StaticTemplateId} from 'pipelines/static-templates/GeneratedStaticTemplateUIShapes';

import {isDataFrameView} from '../AnalysisViewUtils';

export default function getExperimentOptimizationConfigurationAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void
): OverflowDataViewAction | null {
  const {step, stepOutputReference} = view.lineage[view.lineage.length - 1];
  if (isAnalysisReadOnly(analysis) || !isExperimentOptimizationEnabled() || !isDataFrameView(view)) {
    return null;
  }

  const {canEdit, message} = checkCanModifyStep(analysis, step.id, 'table', false);

  return {
    icon: 'settings',
    onClick: () => {
      configureAndApplyStaticTemplate(
        StaticTemplateId.EXPERIMENT_OPTIMIZATION,
        analysis.id,
        [
          {
            step,
            stepDataName: stepOutputReference!.outputStepData.name,
            rawDataIndex: stepOutputReference!.rawDataIndex!,
          },
        ],
        (newSteps) => {
          onChangeSelectedItem({
            type: AnalysisMainViewItemType.DATA_VIEW,
            viewReference: {
              stepId: newSteps[0].id,
              outputReference: {
                stepDataName: newSteps[0].outputStepDatas[0].name,
                rawDataIndex: 0,
              },
            },
          });
        }
      );
    },
    label: 'Configure Experiment Optimization',
    isDisabled: !canEdit,
    helpText: !canEdit ? message : undefined,
  };
}
